import type { CalendarSearchResultProps } from '../components/CalendarSearchResult';
import type CalendarItem from 'owa-service/lib/contract/CalendarItem';
import type { NewOrExistingAsset } from 'owa-timestream-asset-sdk-types';
import type { CalendarItemPayload } from '../schema';
import { calendarItem } from '../index';
import createPayloadObject from './createPayloadObject';

export function createDragAsset(searchProps: CalendarSearchResultProps) {
    const item = searchProps.item;
    if (item.id.indexOf('calendarItem_monthHeader') >= 0) {
        return null;
    }

    const calendarItemData = item.data as CalendarItem;
    const dragAsset: NewOrExistingAsset<CalendarItemPayload> = {
        type: calendarItem.type,
        payload: {
            item: createPayloadObject(calendarItemData),
            itemId: calendarItemData.ItemId?.Id || '',
        },
        existingAssetId: item.existingAssetId,
    };
    return dragAsset;
}
